import React, { useEffect, useCallback, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useMusic } from '../context/MusicContext'

export function BookList() {
  const { API_URL, addBookToUserPlaylist } = useMusic()
  const navigate = useNavigate()
  const [books, setBooks] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const fetchBooks = useCallback(async () => {
    console.log(
      `Fetching books from fetchBooks at${new Date().toISOString()}:`,
      API_URL,
    )
    try {
      setIsLoading(true)
      const response = await fetch(`${API_URL}/books`)
      console.log(
        `Recieved data from fetchBooks at ${new Date().toISOString()}:`,
        API_URL,
      )
      const data = await response.json()
      console.log('BookList data', data)
      // const filteredData = data.filter((artist) => {
      //   return artist.name.toLowerCase() !== 'övriga'
      // })
      setBooks(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Failed to fetch books:', error)
      setBooks([])
    } finally {
      setIsLoading(false)
    }
  }, [API_URL])

  useEffect(() => {
    fetchBooks()
  }, [fetchBooks])

  return (
    <>
      <div>
        <h3>Books Page</h3>
      </div>
      {isLoading && (
        <div className="page-status" role="status" aria-live="polite">
          Laddar böcker...
        </div>
      )}
      {!isLoading && books.length === 0 && (
        <div className="page-status" role="status">
          Inga böcker hittades.
        </div>
      )}
      <div className="artist-grid">
        {books.map((item, index) => (
          <div
            key={index}
            className="artist-card"
            onClick={() => navigate(`/book/${item.book}`)}
          >
            <button
              type="button"
              className="add-to-playlist-button artist-card-add-button"
              title="Lägg till alla kapitel i kön"
              aria-label={`Lägg till alla kapitel från ${item.book} i kön`}
              onClick={(e) => {
                e.stopPropagation()
                addBookToUserPlaylist(item.book)
              }}
            >
              <FaPlus size={18} />
            </button>
            <img
              src={`${API_URL}/book/${item.book}/cover`}
              alt={item.book}
              className="artist-image"
            />
            <h3>{item.book}</h3>
          </div>
        ))}
      </div>
    </>
  )
}
